import { useMemo } from 'react'

import { COMPANY_RADIONET_ID } from '@apps-common/config/company'
import { useAuth } from '@apps-common/contexts'
import { useDevSettingsStore } from '@apps-common/stores'
import { first } from 'lodash'

export interface IPortalFirebaseUser {
  firebaseId: string
  identityId: number
  displayName: string
  userName: string
  fullName: string
  firstName?: string
  companyId: string
  company: string
  isMonitoringCentre: boolean
  isRadionetUser: boolean
  // isMyMonitoringAdmin: boolean
  roles: string[]
  scopes: string[]
}

export const usePortalFirebaseUser = () => {
  const { user } = useAuth()
  const { isMonitoringCentre } = useDevSettingsStore()

  // console.log(user)

  const parseIsMonitoringCentre = (value?: string) => {
    if (value?.toLowerCase() === 'true') return true

    return false
  }

  const data: IPortalFirebaseUser | undefined = useMemo(() => {
    if (!user) return undefined

    const values = user?.idTokenResult?.claims as any

    const getIsMonitoringCentreValue = () => {
      if (isMonitoringCentre !== null) {
        return isMonitoringCentre
      }

      return parseIsMonitoringCentre(values?.isMonCentre as string)
    }

    // const getIsMyMonitoringAdmin = () => {
    //   return (values?.role || []).includes('radionetMyMonitoringMobileApp.admin')
    // }

    return {
      firebaseId: user?.uid || '',
      identityId: parseInt(values?.identityId || '', 10) || 0,
      displayName: values?.displayName || '',
      userName: values?.userName || '',
      fullName: values?.fullName || '',
      firstName: first((values?.fullName || '').split(' ')) || undefined,
      companyId: values?.companyId || '',
      company: values?.company || '',
      isMonitoringCentre: getIsMonitoringCentreValue(),
      isRadionetUser: values?.companyId === COMPANY_RADIONET_ID,
      // isMyMonitoringAdmin: getIsMyMonitoringAdmin(),
      roles: values?.role || [],
      scopes: values?.scope || []
    }
  }, [user, isMonitoringCentre])

  return data
}
